import React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import FsLightbox from 'fslightbox-react';
import { useHorizontalScroll } from './useSideScroll';
import PropTypes from 'prop-types';
import "./ImageList.css"




const listStyling = { 
  display: 'flex',
  overflowX: 'auto',
  maxWidth: 1050,
  marginRight: '1%',
  maxHeight: '390px',
  scrollbarWidth: 'thin',
  scrollbarColor: '#050A44 transparent',
}

const itemStyling = {
    height: 'auto !important;', 
    flexShrink: '0',
    '& .MuiImageListItem-img ': {
        width: 'auto !important', 
        borderRadius: '10px',
        borderColor: '#141419',
        border: 'thick solid',
        objectFit: 'scale-down',
    }

}

SingleLineImageList.propTypes   = {
    screenshotList: PropTypes.array,
}



export default function SingleLineImageList(props){

    const scrollRef = useHorizontalScroll();
    const [lightboxController, setLightboxController] = React.useState({
        toggler: false,
        source: props.screenshotList[1]
    });
    
    function openLightboxOnSlide(path) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            source: path
        })
    }
    
    return (
        <>
            <ImageList className='imageListDiv' ref={scrollRef} variant="woven" sx={listStyling} gap={15}>
                {props.screenshotList.map((item) => {
                    const item2 = encodeURIComponent(item)
                    return (
                        <ImageListItem className='imgItem'  onClick={() => openLightboxOnSlide(item)} sx={itemStyling} cols={1} rows={1} key={item}>
                            <img className="imgScreenshot" src={item} srcSet={`${item2} 2x`} alt={"test"}/>
                        </ImageListItem>
                    )
                })}
            </ImageList>
            <FsLightbox
                toggler={lightboxController.toggler}
                sources={props.screenshotList}
                source={lightboxController.source}
            />
        </>
    );
}